import { MemreSnackbar } from 'components/core';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { AnalyticsService } from 'utils/AnalyticsService';

type ToggleProps = {
  heading?: string;
  message?: string;
  cb?: () => void;
  learnMoreLink?: string;
};

export default function ToggleKnowledgeBank({ courseId }: { courseId: string }) {
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;

  const [props, setProps] = useState<ToggleProps>({});

  useEffect(() => {
    const handleClick = (url: string, type: string) => {
      const button_type = url.includes('v4') ? 'go to v4 dashboard' : 'go to legacy dashboard';
      AnalyticsService.getInstance().track('button_clicked', { button_type });
      if (type === 'old') {
        history.push(url);
      } else {
        // get the base url and append the old route
        const baseUrl = window.location.origin;

        window.open(`${baseUrl}${url}`, '_blank');
      }
    };
    const timer = setTimeout(() => {
      // The helper function now returns the learnMoreLink (if defined) from the mapping.
      const oldRoute = `/courses/${courseId}/analytics?navigationOverride=v3&isV4Embed=1`;
      const newRoute = `/nav/v4/knowledge-bank/${courseId}`;

      const match =
        path === oldRoute
          ? {
              type: 'old',
              path: newRoute,
              learnMoreLink: 'https://www.cerego.com/support/getting-started-with-the-updated-admin-pages',
            }
          : {
              type: 'new',
              path: oldRoute,
              learnMoreLink: 'https://www.cerego.com/support/getting-started-with-the-updated-admin-pages',
            };

      if (match) {
        setProps({
          message:
            match.type === 'new'
              ? 'Looking for the classic experience? Click to go back'
              : 'Want to see the updated look? Click to try it out',
          heading: match.type === 'new' ? 'Updated Page Design' : 'New Page Design Available',
          cb: () => handleClick(match.path, match.type),
          learnMoreLink: match.learnMoreLink,
        });
      } else {
        setProps({});
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [courseId, path, history]);

  return (
    <MemreSnackbar message={props.message} heading={props.heading} cb={props.cb} learnMoreLink={props.learnMoreLink} />
  );
}
